(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-tabs-v1"] && !Shopify.designMode) return;
  try {
    
class MultiTabSection {
  constructor(section) {
    this.section = section;
    this.buttons = section.querySelectorAll('.tab-button');
    this.panes = section.querySelectorAll('.tab-pane');
    this.loadedContents = new Map();
    this.init();
  }

  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const tabId = button.getAttribute('data-tab-id');
        this.activateTab(tabId);
      });
    });

    const activePane = this.section.querySelector('.tab-pane.active');
    if (activePane) {
      this.loadDynamicContent(activePane);
    }
  }

  async loadDynamicContent(pane) {
    const placeholder = pane.querySelector('.dynamic-content-placeholder');
    if (!placeholder) return;

    const elementId = placeholder.getAttribute('data-element-id');
    const loadMethod = placeholder.getAttribute('data-load-method');
    
    if (!elementId) return;

    if (this.loadedContents.has(elementId)) {
      this.displayLoadedContent(placeholder, this.loadedContents.get(elementId), loadMethod);
      return;
    }

    const sourceElement = document.getElementById(elementId);
    
    if (!sourceElement) {
      placeholder.innerHTML = `<div class="error-message" style="color: red; padding: 20px; border: 1px solid red; border-radius: 4px;">
        <strong>Error:</strong> Element with ID "#${elementId}" not found on this page.
        <br><small>Please check the ID and make sure the element exists.</small>
      </div>`;
      return;
    }

    let content;
    if (loadMethod === 'move') {
      content = sourceElement.cloneNode(true);
      sourceElement.remove();
    } else if (loadMethod === 'clone') {
      content = sourceElement.cloneNode(true);
    } else {
      content = document.createElement('div');
      content.className = 'reference-link';
      content.innerHTML = `
        <div style="padding: 20px; border: 1px solid #e1e1e1; border-radius: 4px; text-align: center;">
          <p>Content from <strong>#${elementId}</strong> is available at its original location.</p>
          <a href="#${elementId}" class="scroll-to-element" data-element-id="${elementId}" style="display: inline-block; margin-top: 10px; color: #000; text-decoration: underline;">
            Jump to #${elementId} →
          </a>
        </div>
      `;
      
      const scrollLink = content.querySelector('.scroll-to-element');
      if (scrollLink) {
        scrollLink.addEventListener('click', (e) => {
          e.preventDefault();
          const targetElement = document.getElementById(scrollLink.getAttribute('data-element-id'));
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    }

    this.loadedContents.set(elementId, content);
    this.displayLoadedContent(placeholder, content, loadMethod);
  }

  displayLoadedContent(placeholder, content, loadMethod) {
    if (loadMethod === 'reference') {
      placeholder.innerHTML = '';
      placeholder.appendChild(content);
    } else {
      placeholder.innerHTML = '';
      placeholder.appendChild(content);
      
      const scripts = placeholder.querySelectorAll('script');
      scripts.forEach(oldScript => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    }
  }

  activateTab(tabId) {
    this.buttons.forEach(button => {
      if (button.getAttribute('data-tab-id') === tabId) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });

    this.panes.forEach(pane => {
      if (pane.getAttribute('data-tab-id') === tabId) {
        pane.classList.add('active');
        this.loadDynamicContent(pane);
      } else {
        pane.classList.remove('active');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.multi-tab-section').forEach(section => {
    new MultiTabSection(section);
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.section.classList.contains('multi-tab-section')) {
      new MultiTabSection(event.detail.section);
    }
  });
}

document.addEventListener('ajax:complete', () => {
  document.querySelectorAll('.multi-tab-section').forEach(section => {
    if (!section._multiTabInitialized) {
      new MultiTabSection(section);
      section._multiTabInitialized = true;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-tabs"] && !Shopify.designMode) return;
  try {
    
class MultiTabSection {
  constructor(section) {
    this.section = section;
    this.buttons = section.querySelectorAll('.tab-button');
    this.panes = section.querySelectorAll('.tab-pane');
    this.loadedContents = new Map();
    this.init();
  }

  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const tabId = button.getAttribute('data-tab-id');
        this.activateTab(tabId);
      });
    });

    const activePane = this.section.querySelector('.tab-pane.active');
    if (activePane) {
      this.loadDynamicContent(activePane);
    }
  }

  async loadDynamicContent(pane) {
    const placeholder = pane.querySelector('.dynamic-content-placeholder');
    if (!placeholder) return;

    const elementId = placeholder.getAttribute('data-element-id');
    const loadMethod = placeholder.getAttribute('data-load-method');
    
    if (!elementId) return;

    if (this.loadedContents.has(elementId)) {
      this.displayLoadedContent(placeholder, this.loadedContents.get(elementId), loadMethod);
      return;
    }

    const sourceElement = document.getElementById(elementId);
    
    if (!sourceElement) {
      placeholder.innerHTML = `<div class="error-message">
        <strong>Error:</strong> Element with ID "#${elementId}" not found on this page.
        <br><small>Please check the ID and make sure the element exists.</small>
      </div>`;
      return;
    }

    let content;
    if (loadMethod === 'move') {
      content = sourceElement.cloneNode(true);
      sourceElement.remove();
    } else if (loadMethod === 'clone') {
      content = sourceElement.cloneNode(true);
    } else {
      content = document.createElement('div');
      content.className = 'reference-link';
      content.innerHTML = `
        <p>Content from <strong>#${elementId}</strong> is available at its original location.</p>
        <a href="#${elementId}" class="scroll-to-element" data-element-id="${elementId}">
          Jump to #${elementId} →
        </a>
      `;
      
      const scrollLink = content.querySelector('.scroll-to-element');
      if (scrollLink) {
        scrollLink.addEventListener('click', (e) => {
          e.preventDefault();
          const targetElement = document.getElementById(scrollLink.getAttribute('data-element-id'));
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    }

    this.loadedContents.set(elementId, content);
    this.displayLoadedContent(placeholder, content, loadMethod);
  }

  displayLoadedContent(placeholder, content, loadMethod) {
    placeholder.innerHTML = '';
    placeholder.appendChild(content);
    
    // 重新执行 scripts
    const scripts = placeholder.querySelectorAll('script');
    scripts.forEach(oldScript => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  activateTab(tabId) {
    this.buttons.forEach(button => {
      if (button.getAttribute('data-tab-id') === tabId) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });

    this.panes.forEach(pane => {
      if (pane.getAttribute('data-tab-id') === tabId) {
        pane.classList.add('active');
        this.loadDynamicContent(pane);
      } else {
        pane.classList.remove('active');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.multi-tab-section').forEach(section => {
    new MultiTabSection(section);
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.section.classList.contains('multi-tab-section')) {
      new MultiTabSection(event.detail.section);
    }
  });
}

document.addEventListener('ajax:complete', () => {
  document.querySelectorAll('.multi-tab-section').forEach(section => {
    if (!section._multiTabInitialized) {
      new MultiTabSection(section);
      section._multiTabInitialized = true;
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
